import React, { useEffect } from "react";

import { Button } from "react-bootstrap";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/routes";

import MoreInfoArtistBannerImg from "@assets/Images/MoreInfoArtistBannerImg.jpg";
import MoreInfoArtistBannerMobileImg from "@assets/Images/MoreInfoArtistBannerMobileImg.jpg";
import FAQAccordionGroup from "@components/component-library/Atoms/FAQAccordionGroup/FAQAccordionGroup";
import BannerTextAndButton from "@components/component-library/Molecules/BannerTextAndButton/BannerTextAndButton";
import BannerThreeToEightCols from "@components/component-library/Molecules/BannerThreeToEightCols/BannerThreeToEightCols";
import PublicPagesWrapper from "@components/component-library/Wrappers/PublicPagesWrapper";
import { useAuthenticationContext } from "@context/authentication";
import { FAQs } from "@util/FAQs";

import styles from "./MoreInfo.module.scss";

const Artist = () => {
  const { auth } = useAuthenticationContext();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PublicPagesWrapper className={styles["main-wrapper"]}>
        <div className={styles["card-image"]}>
          <div className={styles["image-container"]}>
            <img
              src={MoreInfoArtistBannerImg}
              alt="Banner image"
              className={classNames(styles["banner-image"], "d-none d-md-block")}
              height="561px"
            />
            <img
              src={MoreInfoArtistBannerMobileImg}
              alt="Banner image"
              className={classNames(styles["banner-image"], "d-md-none")}
            />
            <div className={styles["image-text"]}>
              <h1 className="d-none d-md-block mb-4">Artists</h1>
              <h2 aria-level={1} className="d-md-none mb-4">
                Artists
              </h2>
              <Button
                role="link"
                onClick={() => {
                  navigate(auth?.signInDetails?.loginId ? ROUTES.Dashboard.path : ROUTES.ExternalRegister.path);
                }}
                variant="secondary"
                className={styles["action-button"]}
                size="lg"
              >
                {auth?.signInDetails?.loginId ? "Dashboard" : "Register now"}
              </Button>
            </div>
          </div>
          <caption className="align-self-end text-end monoGrey1 b5 medium py-0">image credit: AlexD75</caption>
        </div>
        <div className="h3 mb-0">
          Under the resale royalty scheme, artists are entitled to receive royalties on certain resales of their work.
          Copyright Agency has been appointed by the Australian Government to collect and pay royalties to artists on
          resales of their artworks.
        </div>
        <div className="py-5">
          <BannerThreeToEightCols
            heading="Key features of the scheme"
            content={
              <div className="h3 mb-0">
                <p>
                  <ul>
                    <li className="mb-2">a 5% royalty is payable on certain resales in Australia</li>
                    <li className="mb-2">
                      it applies to a range of original artworks, including limited edition prints authorised by the
                      artist
                    </li>
                    <li className="mb-2">
                      if a work was in existence on 9 June 2010 a royalty is not payable on the first commercial resale
                      after that date, but is payable on the second and subsequent commercial resales provided they are
                      for $1000 or over and meet other criteria;
                    </li>
                    <li className="mb-2">All resales of $1,000 or more must be reported</li>
                    <li className="mb-2">
                      From 31 March 2024, resale royalty entitlements expanded to include 17 countries that have
                      reciprocal arrangements with Australia; and 9 additional countries were added from 31 March 2025.
                    </li>
                  </ul>
                </p>
              </div>
            }
          />
        </div>
        <p className="h3 mb-0">
          You can find out more information about the scheme in our quick guide for artists below.
        </p>
        <p className="h3 mb-0">
          Please register your details so that we can quickly contact and pay you when you have an eligible resale.
          There is no cost to register.
        </p>
        <div>
          <Button
            role="link"
            onClick={() => {
              navigate(auth?.signInDetails?.loginId ? ROUTES.Dashboard.path : ROUTES.ExternalRegister.path);
            }}
            variant="primary"
            size="lg"
          >
            {auth?.signInDetails?.loginId ? "Dashboard" : "Register now"}
          </Button>
        </div>
        <BannerTextAndButton
          bannerContent="Looking for more information about the scheme? Find out which artworks are covered, when a royalty is payable, resales in other countries, and more in our quick guide for artists."
          buttonLabel="Find out more"
          href="/ARTISTS_QUICK_GUIDE_2025.pdf"
        />
        <div className={styles["faq-wrapper"]}>
          <BannerThreeToEightCols heading="FAQs" content={<FAQAccordionGroup qnas={FAQs.artist} />} />
        </div>
      </PublicPagesWrapper>
    </div>
  );
};

export default Artist;
